// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__29vi5","options":"AnswerScale_options__1XWb9","selected":"AnswerScale_selected__tyfyj"};